module.exports = __webpack_public_path__ + "media/assets/EllipseYellow-d9a29efa0b5fbcb2411eb873ad3c65cd.svg";